import React, { useState } from 'react';
import { Grid, TextField, Button } from '@nextiva/next-ui-components';

import { verifyDomain } from 'api/domainApi';
import VerifyDrawer from 'containers/pages/Email/VerifyDrawer';
import AddressEntry from 'containers/pages/Email/AddressEntry';

import styles from '../VerifyDrawer/VerifyDrawer.scss';

const parseCodeFromRoute = () => {
  const match = window.location.hash.match(/\?code=(\d{6})/);

  return match ? match[1] : '';
};

const VerifyCode = ({ handleSuccess, open, initialEmail, toggleDrawer }) => {
  const domain = initialEmail.split('@').pop();
  const [errorMessage, setErrorMessage] = useState(null);
  const [verificationCode, setVerificationCode] = useState(
    parseCodeFromRoute(),
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (verificationCode.match(/^\d{6}$/)) {
      try {
        await verifyDomain(verificationCode);
        setErrorMessage(null);
        handleSuccess();
      } catch (f) {
        setErrorMessage(f.errors[0].detail);
      }
    } else {
      setErrorMessage('Please enter a valid verification code');
    }
  };

  return (
    <VerifyDrawer {...{ open, toggleDrawer }}>
      <AddressEntry readOnly handleSuccess={() => {}} {...{ initialEmail }} />
      <Grid className={styles.container} container spacing={0}>
        <Grid className={styles.title} item xs={12}>
          Enter the verification code from your email
        </Grid>
        <Grid className={styles.instructions} item xs={12}>
          <p>
            We’ve just sent a verification email to{' '}
            <strong>{initialEmail}</strong> to verify the domain{' '}
            <strong>{domain}</strong>. Be sure to check your junk mail folder
            just in case!
          </p>
          <p>
            To verify, click “Verify Domain” in the email or enter the
            verification code below:
          </p>
        </Grid>
        <Grid className={styles.textField} item xs={12}>
          <form
            onSubmit={handleSubmit}
            data-testid="PlatformAdminUI-VerifyCode-Form"
          >
            <TextField
              type="number"
              label="verification code"
              fullWidth
              value={verificationCode}
              error={errorMessage !== null}
              helperText={errorMessage}
              onChange={(e) => setVerificationCode(e.target.value)}
              data-testid="PlatformAdminUI-VerifyCode-TextField"
            />
          </form>
        </Grid>
        <Grid className={styles.sendVerificationButton} item xs={5}>
          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={handleSubmit}
            data-testid="PlatformAdminUI-VerifyCode-VerifyDomain"
          >
            Verify Domain
          </Button>
        </Grid>
      </Grid>
    </VerifyDrawer>
  );
};

export default VerifyCode;
